/* RegexMode.js */

"use strict";

module.exports = {
    MATCH_SINGLE_LINES: {value: "match_single_lines", displayValue: "MATCH SINGLE LINES"},
    MATCH_ALL_LINES: {value: "match_all_lines", displayValue: "MATCH ALL LINES"},
    MATCH_SECTIONS: {value: "match_sections", displayValue: "MATCH SECTIONS"},
    isValidMode(mode) {
        return (
            mode &&
            (mode === this.MATCH_SINGLE_LINES.value ||
                mode === this.MATCH_ALL_LINES.value ||
                mode === this.MATCH_SECTIONS.value)
        );
    },
};
